export default __webpack_public_path__ + "static/media/Talent_Quest_GhostTree.1c10cc20.png";